import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AuthContextEnum } from '@feature-auth';
import { ButtonUIComponent, IconUIComponent, LogoUIComponent } from '@shared-ui-kit';
import {
  injectLandingActions,
  injectLandingSeo,
  VideoAutoplay,
  WebAboutSection,
  WebCardV1,
  WebCriticalFreight,
  WebParallaxBg,
  WebStatistics,
  LANDING_VIDEOS,
} from '@feature-landing';

@Component({
  selector: 'fr8bot-main-page',
  imports: [
    IconUIComponent,
    ButtonUIComponent,
    WebCardV1,
    WebAboutSection,
    WebCriticalFreight,
    WebStatistics,
    WebParallaxBg,
    VideoAutoplay,
    TranslatePipe,
    LogoUIComponent,
  ],
  templateUrl: './main-page.html',
  styleUrl: './main-page.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPage {
  protected readonly videos = LANDING_VIDEOS;

  constructor() {
    injectLandingSeo('main');
  }

  protected readonly landing = injectLandingActions();
  protected readonly AUTH_CONTEXT = AuthContextEnum;
}
